import { styled, TableRow as MuiTableRow } from '@material-ui/core';

export const InsetTableRow = styled(MuiTableRow)({
  '& > *:first-child': {
    paddingLeft: '54px',
  },
});
